import { useCallback } from "react";

import styled from "styled-components";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import FnrTypography from "FnrTypography";

import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrTappyShrink from "UI/FnrTappyShrink";
import { marketingColors } from "UI/colors";

import { useCopyTextColor } from "../stateHooks";

import MainOptionButtonWrapper from "./MainOptionButtonWrapper";

const DefaultInquiryButtonDisplay = () => {
  const { contextInquiryText } = useMemberToobarContext();
  const textColor = useCopyTextColor();

  return (
    <Wrapper>
      <FnrContainedIcon
        size="xl"
        color={marketingColors.sky}
        icon="comment-alt fal"
      />
      <FnrTypography color={textColor} bold type="copy">
        {contextInquiryText}
      </FnrTypography>
    </Wrapper>
  );
};

const Wrapper = styled(FnrTappyShrink)`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const DefaultInquiryButton = () => {
  const {
    flocknoteSupport,
    generalInquiry,
    prayerRequest,
    formWasActive,
    setFlocknoteSupport,
    setGeneralInquiry,
    setPrayerRequest,
    setActiveContentKey,
    setFormWasActive,
  } = useMemberToobarContext();

  const showDefaultInquiry = useCallback(() => {
    setActiveContentKey(contentKeys.form);
    setFormWasActive(true);
    setGeneralInquiry(false);
    setFlocknoteSupport(false);
    setPrayerRequest(false);
  }, [
    setActiveContentKey,
    setFormWasActive,
    setGeneralInquiry,
    setFlocknoteSupport,
    setPrayerRequest,
  ]);

  return (
    <MainOptionButtonWrapper
      onClick={showDefaultInquiry}
      autoFocus={
        !flocknoteSupport && !generalInquiry && !prayerRequest && formWasActive
      }
      DisplayComponent={DefaultInquiryButtonDisplay}
      data-cy="MemberToolbar_DefaultInquiryButton"
    />
  );
};

export default DefaultInquiryButton;
